// extracted by mini-css-extract-plugin
module.exports = {"uk-h5-title":"style_uk-h5-title__U4tvS"};